import {SupportedLanguages} from 'interfaces';

export const naturalComparator = (locale?: SupportedLanguages) => {
  return new Intl.Collator(locale ?? SupportedLanguages.norwegian, {numeric: true, sensitivity: 'base'}).compare;
};
